module.exports = __webpack_public_path__ + "static/img/banner_contact.7459bd0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner_contact.jpg
// module id = nXXz
// module chunks = 2